import React from "react";

import Markdown from "react-markdown";
import SubHeading from "../../../components/common/heading/SubHeading";
const Travel = ({ data }) => {
  return (
    <section id="travel-section" className="lg:pt-0 pt-[3vw]">
      {data.map((section, index) => (
        <div
          id={`travel_${index + 1}`}
          key={index}
          className={`container-fluid mb-[1.5vw] ${
            index === 1 ? "bg-[#E6EAEF] py-[7.67vh]" : ""
          }`}
        >
          <div className="container">
            <div className="flex justify-center">
              <div className="lg:w-fit text-center border-b-[0.15vw] border-[#F77D0D]">
                <h2
                  className="font-redhatMedium lg:text-[2.5vw] text-[5.5vw]"
                  style={{ color: section.heading_color || "#002C62" }}
                >
                  {section.heading}
                </h2>
              </div>
            </div>
            <div
              className={`grid grid-cols-1 gap-[1.35vw] ${
                index === 1 ? "md:grid-cols-2" : "md:grid-cols-3"
              } text-center md:text-left`}
            >
              {section.cards?.map((card, idx) => (
                <div
                  key={idx}
                  className={` rounded-xl p-[1.35vw] ${
                    idx === 1 ? "border-l border-r border-gray-200" : ""
                  }`}
                >
                  <img
                    className="rounded-lg h-[11.17vw] md:h-[4.17vw] mb-[0.5vw] mx-auto md:mx-0 md:ml-0"
                    src={card.card_image?.url}
                    //alt={card.card_image?.alternativeText || "Travel image"}
                    alt=""
                    aria-hidden="true"
                  />

                  <h3
                    className="text-[4.5vw] md:text-[1.34vw] font-redhatMedium my-[1.25vw]"
                    style={{ color: card.heading_color }}
                  >
                    {card.heading}
                  </h3>

                  <p className="text-[#667083] text-[2.9vw] md:text-[1.34vw] font-redhatRegular">
                    <Markdown>
                      {card.description?.data?.description || ""}
                    </Markdown>
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default Travel;
